import React, { PropsWithChildren } from "react";
import { connect } from "react-redux";
import { Card, Layout } from "antd";
import { Redirect, useHistory, useLocation } from "react-router-dom";
import logo from "../../../assets/images/logo_white.png";
import LoginForm from "./LoginForm";
import { signUp } from "../../../actions/auth";
import { AppState } from "../../../reducers";
import { MetaTitle } from "../../Shared/MetaTitle";

interface ILoginProps {
  isRequest: boolean;
  isLogged: boolean;
  signUpAction: (
    username: string,
    password: string,
    remember: boolean
  ) => Promise<void>;
}

interface ILocationStateType {
  from: { pathname: string };
}

const Login: React.FC<PropsWithChildren<ILoginProps>> = (
  props: PropsWithChildren<ILoginProps>
): JSX.Element => {
  const { Content } = Layout;
  const location = useLocation<ILocationStateType>();
  const history = useHistory();

  const { signUpAction, isRequest, isLogged } = props;
  const handleSubmit = (
    username: string,
    password: string,
    remember: boolean,
    setStatus: (status: string) => void
  ) => {
    signUpAction(username, password, remember)
      .then(() => {
        const { from } = location.state || { from: { pathname: "/" } };
        history.replace(from);
      })
      .catch((error) => {
        if (!error?.status || error.status >= 500) {
          setStatus(
            "Nie można połączyć się z serwerem. Spróbuj ponownie za chwilę."
          );
          return;
        }

        if (error.status === 403 || error.data?.code === 403) {
          setStatus("Konto jest nieaktywne");
        } else if (error.status === 401) {
          setStatus("Nieprawidłowe dane logowania");
        } else {
          setStatus("Logowanie nie powiodło się. Spróbuj ponownie.");
        }
      });
  };

  if (isLogged) {
    return (
      <Redirect
        to={{
          pathname: "/",
          state: { from: location },
        }}
      />
    );
  }

  return (
    <Layout>
      <MetaTitle title="Logowanie" displayBadge={false} />
      <Content className="auth-login auth-login--sign-in">
        <div className="auth-login__logo-container">
          <img src={logo} className="auth-login__logo" alt="POS Driver" />
        </div>
        <Card className="auth-login__card" bordered title="Logowanie">
          <LoginForm handleSubmit={handleSubmit} isRequest={isRequest} />
        </Card>
        <p className="auth-login__footer">© 2026 ABS DRIVE v1.0.2 09.09</p>
      </Content>
    </Layout>
  );
};

const mapStateToProps = (state: AppState) => {
  return {
    isRequest: state.auth.isRequest,
    isLogged: state.auth.isLogged,
  };
};

const mapDispatchToProps = {
  signUpAction: signUp,
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
